/**
 * Единый вид телефонов «+7 937 279-85-22» и ссылки на Telegram (Чат 4, доработка №15, 04.11). [Claude] 2026-11-04
 * Сервер хранит российские номера в этом же виде (app/utils/phone_format.py).
 */

/** 11 digits starting with 7 for a Russian number (8…, +7…, 9… without code), else null. */
export function phoneDigits(value) {
    let digits = String(value ?? "").replace(/\D/g, "");
    if (digits.length === 10 && digits.startsWith("9")) digits = `7${digits}`;
    if (digits.length === 11 && (digits[0] === "7" || digits[0] === "8")) return `7${digits.slice(1)}`;
    return null;
}

/** Display form: «+7 937 279-85-22»; anything that is not a Russian number is returned as is. */
export function formatPhone(value) {
    if (value === null || value === undefined) return value;
    const text = String(value).trim();
    const d = phoneDigits(text);
    if (!d) return text;
    return `+7 ${d.slice(1, 4)} ${d.slice(4, 7)}-${d.slice(7, 9)}-${d.slice(9, 11)}`;
}

/**
 * Live formatting while typing: the number always starts with +7, spaces and dashes are added
 * by themselves. Text with letters or a foreign code (+44…) is left as typed.
 */
export function formatPhoneInput(raw) {
    const text = String(raw ?? "");
    if (!text.trim()) return "";
    if (/[^\d\s()+\-.]/.test(text)) return text;
    if (/^\s*\+(?!\s*7)/.test(text)) return text;
    let d = text.replace(/\D/g, "");
    if (!d) return "+7";
    if (d.startsWith("8")) d = `7${d.slice(1)}`;
    else if (!d.startsWith("7")) d = `7${d}`;
    const p = d.slice(1, 11);
    let out = "+7";
    if (p.length) out += ` ${p.slice(0, 3)}`;
    if (p.length > 3) out += ` ${p.slice(3, 6)}`;
    if (p.length > 6) out += `-${p.slice(6, 8)}`;
    if (p.length > 8) out += `-${p.slice(8, 10)}`;
    return out;
}

/** https://t.me/<username> for «@name», «name» or «t.me/name»; null for numeric chat IDs and garbage. */
export function telegramUrl(value) {
    const text = String(value ?? "").trim().replace(/^https?:\/\/(www\.)?t(elegram)?\.me\//i, "").replace(/^@/, "");
    if (!/^[A-Za-z][A-Za-z0-9_]{3,31}$/.test(text)) return null;
    return `https://t.me/${text}`;
}

/** «@name» — how a Telegram username is shown. */
export function telegramText(value) {
    const text = String(value ?? "").trim();
    if (!text) return "";
    return /^-?\d+$/.test(text) || text.startsWith("@") ? text : `@${text}`;
}

/** Чей контакт: рабочий / личный / общий; null — не указан. Same keys as contact_points.usage_type. */
export const CONTACT_USAGE = [
    ["work_personal", "рабочий"],
    ["personal", "личный"],
    ["shared", "общий"],
];
export const USAGE_SHORT = { work_personal: "раб.", personal: "личн.", shared: "общий" };
export const usageLabel = (usage) => (CONTACT_USAGE.find(([key]) => key === usage)?.[1] || "не указан");
export const usageShort = (usage) => USAGE_SHORT[usage] || "не указан";
